/* @flow */

import React from 'react';
import { Form, FormGroup, FormFeedback } from 'reactstrap';
import { InputField, RegistrationForm } from './';
import { Field, reduxForm } from 'redux-form';
import { required, email } from './validations';
import Translations from '../hocs/TranslationsHelper';
import type { ReduxFormFunction, ReduxFormErrorGlobal, ReduxFormFlag, TranslationsObject } from '../components/types';
import classNames from 'classnames';
import RegistrationSubmitButton from './RegistrationSubmitButton';

type Props = {
  handleSubmit: ReduxFormFunction,
  translations: TranslationsObject,
  error: ReduxFormErrorGlobal,
  submitting: ReduxFormFlag,
  queryParams?: Object,
  onBackButtonClick: () => mixed
};

/**
 * component to display the user password new form
 *
 * @method UserPasswordNewForm
 * @param  {Function}  handleSubmit - injected by 'redux-form', supposed to handle submit
 *
 */
const UserPasswordNewForm = ({ handleSubmit, translations, error, submitting, onBackButtonClick, ...otherProps }: Props) => {
  const formClassName = classNames({ 'has-danger': error }, 'form');
  const disabled = submitting;

  return (
    <RegistrationForm
      title={translations.t('user_password_new_form_title')}
      subtitle={translations.t('user_password_new_form_subtitle')}>
      <Form id="user-password-new-form" className={formClassName} onSubmit={handleSubmit}>
        {
          error &&
          <FormGroup>
            <FormFeedback>{translations.t(error)}</FormFeedback>
          </FormGroup>
        }
        <Field
          className="text-center lowercased"
          type="text"
          name="email"
          placeholder={translations.t('email_placeholder')}
          disabled={disabled}
          component={InputField}
          validate={[ required, email ]}
        />
        <div className="registration-form-button-wrapper">
          <RegistrationSubmitButton loading={submitting}>
            {translations.t('continue')}
          </RegistrationSubmitButton>
          <span className="registration-form-next-icon pleiq-icon-icon_arrow_right" />
        </div>
      </Form>
    </RegistrationForm>
  );
};

export const FORM_NAME = 'userPasswordNewForm';

export default reduxForm({
  form: FORM_NAME
})(Translations(UserPasswordNewForm));
